// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".width-order-overview[data-v-6498bdaf]{max-width:500px;margin-left:auto;margin-right:auto}.warning[data-v-6498bdaf]{color:#ff7272}", ""]);
// Exports
module.exports = exports;
